/**
 * Centralized structured logger — single place to swap console for Sentry/Datadog.
 *
 * HOW TO ADD SENTRY:
 *   1. npm install @sentry/nextjs
 *   2. Run `npx @sentry/wizard@latest -i nextjs`
 *   3. In reportError() below, uncomment the two Sentry lines
 *   4. Optionally remove the console.error fallback once Sentry is confirmed working
 */

import {ApiError} from './ApiError';

/** Report an error to the central error tracking service. */
export function reportError(error: unknown, context?: Record<string, unknown>): void {
    // Skip intentionally cancelled requests — these are not errors.
    if (error instanceof ApiError && error.isCancelled) return;

    // No error tracking service is wired up yet — when one is configured, report the
    // error here (with `context` as extra data) before the console fallback below.

    // Fires in ALL environments (dev + production).
    // In production this surfaces in deployment logs (Vercel, AWS, etc.)
    // until a proper error tracking service is connected above.
    console.error('[ApiError]', {
        name: error instanceof Error ? error.name : 'UnknownError',
        message: error instanceof Error ? error.message : String(error),
        ...(error instanceof ApiError && {
            code: error.code,
            status: error.status,
            url: error.url,
            method: error.method,
            isNetwork: error.isNetwork,
            isTimeout: error.isTimeout
        }),
        ...context
    });
}
